import React, { Component } from 'react';

import { MyInput } from '../elements/MyInput';
import { PrizeTable } from '../tables/prize/PrizeTable';



export class PrizePage extends Component {


  constructor(props) {
    super(props);
    this.state = { isLoading: false };
    this.state.data = {};
    //  this.incrementCounter = this.incrementCounter.bind(this);
    this.onFormChange = this.onFormChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleTextChange = this.handleTextChange.bind(this);





    var token = localStorage.getItem('token');
    this.headers =
    {
      'Content-Type': 'application/json',
      'AuthorizationToken': token
    };
  }

  handleSubmit(e) {
    e.preventDefault();


    this.setState({ isLoading: true });
    var data = this.state.data;
    //    console.log(data);

    fetch('api/v1/AddPrize',
      {
        method: 'POST',
        body: JSON.stringify(data),
        headers: this.headers
      }).then(res => {
        this.status = res.status;

        res.json().then((result) => {

          if (this.status == 200) {
            alert('OK');
          }
          else {
            console.log(result);
            alert(result.Value);

          }
          this.setState({ isLoading: false });
          this.setState({});
        },
          (error) => {
            this.setState({ isLoading: false });
          }
        );
      }
      );


  }
  onFormChange() {

  }

  handleTextChange(e, key) {
    //   console.log(e);
    this.state.data[key] = e;
    this.setState({});
  }





  render() {
    if (this.state.isLoading) {
      return <div>...</div>
    }
    return (

      <div>



        <PrizeTable>

        </PrizeTable>


        <div className="row">
          <div className="col-md-4">
          </div>
          <div className="col-md-4 col-sm-12">
            <form className="" onSubmit={this.handleSubmit} ref="myRef">
              <MyInput onChange={this.handleTextChange} label="عنوان" name="Name" ></MyInput>
              <br />
              <MyInput onChange={this.handleTextChange} label="توضیحات" name="Description" ></MyInput>
              <br />
              <button className="btn btn-primary" onClick={this.handleSubmit}>اضافه کردن</button>
              <br />
            </form>

          </div>

        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PrizePage.js